import React from 'react';

// Constellation Components
import { Anchor } from '@zillow/constellation';

// Styled Components
import { StyledText } from './StyledComponents';

const PaidMFDisabledFieldMessage = (props) => {
    const { formData, section, ...rest } = props;

    let parsePropertyAddress = [
        formData.street,
        formData.city, ',',
        formData.state,
    ].join(' ');

    parsePropertyAddress = parsePropertyAddress.replace(' ', '%20');
    const emailSubjectForPropertyChange = `Update%20listing%20${section}%20for%20${parsePropertyAddress}`;

    return (
        <StyledText {...rest}>
            {`To update this property ${section}, please contact: `}
            <Anchor href={`mailto:rentalpartners@zillowgroup.com?subject=${emailSubjectForPropertyChange}`}>
                RentalPartners@zillowgroup.com
            </Anchor>
            .
        </StyledText>
    );
};

export default PaidMFDisabledFieldMessage;
